import { Button } from "@mui/material";
import { HomeIcon, LockIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { useSignOut } from "Auth/Hooks/useSignOut";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const Error403Page: React.FunctionComponent = (_) => {
  const { t } = useResource();

  const signOut = useSignOut();

  return (
    <UnauthenticatedLayout title={"403"}>
      <EmptyPage
        icon={<LockIcon />}
        title={t(Resources.Errors.Error403.Title)}
        subtitle={t(Resources.Errors.Error403.Subtitle)}
        actions={
          <>
            <UnstyledLink to="/">
              <Button startIcon={<HomeIcon />} variant="contained">
                {t(Resources.Errors.Error404.Home)}
              </Button>
            </UnstyledLink>

            <Button variant="contained" onClick={() => signOut()}>
              {t(Resources.Common.SignOut)}
            </Button>
          </>
        }
      />
    </UnauthenticatedLayout>
  );
};
